// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\ntable[data-v-42a09e5b] {\n  width: 100%;\n  border-collapse: collapse;\n}\ntable[data-v-42a09e5b], th[data-v-42a09e5b], td[data-v-42a09e5b] {\n  border: 1px solid black;\n}\nth[data-v-42a09e5b], td[data-v-42a09e5b] {\n  padding: 5px;\n  text-align: left;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
